const menuConfigs = [
  {
    type: 'collapse',
    title: '二级导航',
    settings: [{
      type: 'status',
      showTitle: false,
      statusSettings: [{
        title: '默认',
        settings: [{
          title: '文字',
          type: 'subCollapse',
          settings: ['secondNavTitle']
        }, {
          title: '背景',
          type: 'subCollapse',
          settings: ['secondNavTitleBackground']
        },
          {
          title: '图标',
          type: 'subCollapse',
          settings: ['secondNavIcon']
        },
          {
          title: '边框',
          type: 'subCollapse',
          settings: ['secondNavTitleBorder', 'secondRadius']
        }, {
          title: '边距',
          type: 'subCollapse',
          settings: ['secondNavPadding']
        }, {
          title: '分隔线',
          type: 'subCollapse',
          settings: ['secondTitleBorderWidth', 'secondTitleBorderColor']
        }]
      }, {
        title: '选中',
        settings: [{
          title: '文字',
          type: 'subCollapse',
          settings: ['secondNavActiveTitle']
        }, {
          title: '背景',
          type: 'subCollapse',
          settings: ['secondActiveNavTitleBackground']
        }, {
          title: '边框',
          type: 'subCollapse',
          settings: ['secondNavTitleActiveBorder', 'secondActiveRadius']
        }, {
          title: '边距',
          type: 'subCollapse',
          settings: ['secondNavActivePadding']
        }]
      }, {
        title: '悬浮',
        settings: [{
          title: '文字',
          type: 'subCollapse',
          settings: ['secondNavHoverTitle']
        }, {
          title: '背景',
          type: 'subCollapse',
          settings: ['secondHoverNavTitleBackground']
        }, {
          title: '边框',
          type: 'subCollapse',
          settings: ['secondNavTitleHoverBorder', 'secondHoverRadius']
        }, {
          title: '边距',
          type: 'subCollapse',
          settings: ['secondNavHoverPadding']
        }]
      }]
    }]
  },
  {
    type: 'collapse',
    title: '三级导航',
    settings: [{
      type: 'status',
      showTitle: false,
      statusSettings: [{
        title: '默认',
        settings: [
        {
          title: '尺寸',
          type: 'subCollapse',
          settings: ['widthType', {
            type: 'basic',
            name: 'widthValue',
            enable(config) {
              return config.widthType === 'fixed'
            }
          }]
        },
        {
          title: '文字',
          type: 'subCollapse',
          settings: ['thirdNavTitle']
        }, {
          title: '最大标题行数',
          type: 'subCollapse',
          settings: ['thirdNavTitleLines']
        },{
          title: '背景',
          type: 'subCollapse',
          settings: ['thirdNavTitleBackground']
        }, {
          title: '边框',
          type: 'subCollapse',
          settings: ['thirdTitleBorder', 'thirdTitleRadius']
        },
        {
          title: '图标',
          type: 'subCollapse',
          settings: ['thirdNavIcon']
        }, {
          title: '行间距',
          type: 'subCollapse',
          settings: ['thirdNavTitleMargin']
        }, {
          title: '边距',
          type: 'subCollapse',
          settings: ['thirdNavPadding']
        }]
      }, {
        title: '选中',
        settings: [{
          title: '文字',
          type: 'subCollapse',
          settings: ['thirdActiveNavTitle']
        }, {
          title: '圆角',
          type: 'subCollapse',
          settings: ['thirdActiveRadius']
        }, {
          title: '边框',
          type: 'subCollapse',
          settings: ['thirdTitleActiveBorder']
        }, {
          title: '背景',
          type: 'subCollapse',
          settings: ['thirdActiveNavTitleBackground']
        }]
      }, {
        title: '悬浮',
        settings: [{
          title: '文字',
          type: 'subCollapse',
          settings: ['thirdHoverNavTitle']
        }, {
          title: '圆角',
          type: 'subCollapse',
          settings: ['thirdHoverRadius']
        }, {
          title: '边框',
          type: 'subCollapse',
          settings: ['thirdTitleHoverBorder']
        }, {
          title: '背景',
          type: 'subCollapse',
          settings: ['thirdHoverNavTitleBackground']
        }]
      }]
    }]
  },
  {
    type: "collapse",
    title: "菜单列表",
    settings: [
      {
        type: "subCollapse",
        settings: ["navPopPosition"],
        title: "位置"
      },
      {
        type: "subCollapse",
        settings: ["navSite"],
        title: "排列"
      },
      {
        type: "subCollapse",
        settings: ["navSize"],
        title: "尺寸"
      },
      {
        type: "subCollapse",
        settings: ["wholeBackground"],
        title: "背景"
      },
      {
        type: "subCollapse",
        settings: ["navBorder", "navBorderRadius"],
        title: "边框"
      },
      {
        type: "subCollapse",
        settings: ["navPadding"],
        title: "边距"
      },
      {
        type: "subCollapse",
        settings: [
          "navGap",
          "navBoxShadow",
          "showConnector",
          {
            enable(config) {
              return config.showConnector
            },
            type: "block",
            settings: ["connectorColor", "connectorWidth"]
          },
        ],
        title: "更多"
      }
    ]
  }
]

export default menuConfigs
